<template>
  <div>
    <SignIn :signInType="signInType" />
  </div>
</template>

<script>
import SignIn from "@/components/Account/SignIn.vue";
export default {
  components: {
    SignIn,
  },
  computed: {
    signInType() {
      const name = this.$route.name;
      if (name.includes("sign-in-user")) return "user";
      else return "admin";
    },
  },
};
</script>

<style></style>
